import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import "../CSS/font.css";
import logo from "../assests/logo.jpeg";
import man from "../assests/AI.mp4";
import man1 from "../assests/data.mp4";
import man2 from "../assests/Lang.mp4";
import man3 from "../assests/editing.mp4";
import bgVideo from "../assests/Main.mp4";
import ContactForm from "./ContactForm";
import AboutUs from "./AboutUs";

function storeScrollPosition() {
  const scrollY = window.scrollY;
  sessionStorage.setItem('scrollPosition', scrollY);
}

const caseStudies = [
  {
    title: "Scaling Multilingual Chatbots",
    description:
      "We helped a global tech firm train chatbots in 12 languages using culturally accurate data. " +
      "Our team ensured each language model understood local nuances, idioms, and context, which improved the chatbot's natural conversation capabilities. " +
      "The project included dialogue annotation, context tagging, and extensive QA to maintain high accuracy and cultural relevance."
  },
  {
    title: "Healthcare AI with Human Touch",
    description:
      "Our annotation team enabled a medical AI to detect rare conditions with 98% accuracy. " +
      "We provided meticulously labeled datasets covering radiology, pathology, and clinical notes, ensuring the AI could identify patterns in both common and rare cases. " +
      "Collaboration with healthcare professionals ensured ethical and safe data practices throughout the process."
  },
  {
    title: "Retail Voice Assistant",
    description:
      "We localized voice commands for a retail assistant across 8 regions, boosting adoption by 40%. " +
      "This involved translating voice intents, testing pronunciation variations, and integrating regional slang. " +
      "Our team optimized the assistant to respond naturally in each locale, enhancing user satisfaction and engagement."
  },
  {
    title: "Autonomous Vehicle Perception",
    description:
      "We provided annotated image and video datasets for training self-driving vehicle AI. " +
      "This included object detection, lane marking recognition, and pedestrian identification across various environmental conditions, improving safety and performance."
  },
  {
    title: "E-commerce Recommendation Engine",
    description:
      "We curated large-scale product datasets with user behavior metadata to enhance recommendation algorithms. " +
      "Our team focused on multilingual product descriptions, images, and user interactions to make the AI more personalized and globally relevant."
  }
];

const services = [
  { title: "Image & Video Collection", icon: "🖼️", style: "from-cyan-600 to-blue-700" },
  { title: "Dubbing & Transcription", icon: "🎙️", style: "from-purple-600 to-pink-600" },
  { title: "Annotation & Labeling", icon: "🏷️", style: "from-emerald-600 to-teal-600" },
  { title: "Translation & Localization", icon: "🌍", style: "from-orange-500 to-amber-500" },
  { title: "Video Editing & Animation", icon: "🎞️", style: "from-indigo-600 to-sky-600" },
];

const benefits = [
  { title: "Precision & Accuracy", icon: "🎯", bg: "from-blue-700 to-blue-600" },
  { title: "Scalable Global Workforce", icon: "🌐", bg: "from-green-700 to-green-600" },
  { title: "Multilingual Expertise", icon: "🗣️", bg: "from-yellow-600 to-yellow-500" },
  { title: "Human + AI Collaboration", icon: "🤝", bg: "from-pink-600 to-pink-500" },
];

const features = [
  { title: "Diverse Global Contributors", desc: "Real-world cultural diversity.", color: "from-cyan-500 to-blue-500" },
  { title: "Human-in-the-Loop Quality Control", desc: "Verified accuracy.", color: "from-emerald-500 to-teal-500" },
  { title: "Transparency & Ethics", desc: "Ethical sourcing, privacy-first.", color: "from-purple-500 to-pink-500" },
  { title: "Scalability & Speed", desc: "Delivering from pilots to large-scale projects.", color: "from-orange-400 to-amber-500" },
];

const steps = [
  { title: "Scope", icon: "📋" },
  { title: "Strategy", icon: "🧠" },
  { title: "Collection", icon: "📦" },
  { title: "Annotation & QA", icon: "✅" },
  { title: "Delivery", icon: "🚚" },
  { title: "Support", icon: "💬" },
];

const servicesAndVideos = [
  {
    title: "Data Collection",
    icon: "🖼️",
    video: man1,
    items: [
      { label: "Image & Video Collection", path: "/services/image-video" },
      { label: "Audio Collection", path: "/services/audio" },
      { label: "Text Data Sourcing", path: "/services/text" }
    ]
  },
  {
    title: "Data Processing & Enhancement",
    icon: "🏷️",
    video: man,
    items: [
      { label: "Annotation & Labeling", path: "/services/annotation" },
      { label: "Audio & Video Tagging", path: "/services/tagging" },
      { label: "Text & Speech QA", path: "/services/qa" }
    ]
  },
  {
    title: "Language & Localization",
    icon: "🌐",
    video: man2,
    items: [
      { label: "Multilingual Transcription", path: "/services/transcription" },
      { label: "Translation & Localization", path: "/services/translation" },
      { label: "Dubbing & Voiceover", path: "/services/dubbing" }
    ]
  },
  {
    title: "Creative & Media Solutions",
    icon: "🎬",
    video: man3,
    items: [
      { label: "Video Editing", path: "/services/editing" },
      { label: "Content Creation", path: "/services/content" },
      { label: "Animation (2D & 3D)", path: "/services/animation" },
      { label: "Video Projects", path: "/services/projects" }
    ]
  }
];

const industries = [
  { label: "Technology & AI", icon: "🤖", href: "/industries/technology" },
  { label: "E-commerce & Retail", icon: "🛒", href: "/industries/ecommerce" },
  { label: "Healthcare", icon: "🩺", href: "/industries/healthcare" },
  { label: "Automotive", icon: "🚗", href: "/industries/automotive" },
  { label: "Media & Entertainment", icon: "🎬", href: "/industries/media" },
];

function Single1() {
  useEffect(() => {
    document.title = "Prisu Experts | High-Quality Data Solutions for AI & ML";
    const meta = document.querySelector("meta[name='description']") || document.createElement("meta");
    meta.name = "description";
    meta.content =
      "Power your AI with culturally authentic, high-quality, multilingual data solutions. Discover how The Prisu Experts helps build smarter, scalable, and inclusive AI systems.";
    if (!document.head.contains(meta)) document.head.appendChild(meta);

    const savedScrollY = sessionStorage.getItem('scrollPosition');
    if (savedScrollY !== null) {
      window.scrollTo(0, parseInt(savedScrollY));
      sessionStorage.removeItem('scrollPosition'); // Optional cleanup
    }

   
  }, []);
   const sections = [
 <ContactForm/>,
 <AboutUs/>
   ];
   const [videoLoaded, setVideoLoaded] = useState(false);
  return (
    <main className="font-raleway text-white overflow-hidden">
      {/* Hero Section */}

       <div className="fixed inset-0 -z-10 w-full h-full overflow-hidden">
              <video
                autoPlay
                muted
                loop
                playsInline
             
                
              >
                <source src={bgVideo} type="video/mp4" />
              </video>
              <div className="absolute inset-0 bg-gradient-to-br from-black/70 via-black/50 to-black/70"></div>
            </div>
      <section className="relative w-full min-h-screen">
        <motion.div
          className="absolute top-1/2 left-1/2 w-[500px] h-[500px] rounded-full opacity-40 blur-3xl z-10"
          style={{ transform: "translate(-50%, -50%)" }}
          animate={{ rotate: 360 }}
          transition={{ repeat: Infinity, duration: 90, ease: "linear" }}
        />
        <motion.div
          className="absolute -top-32 -left-32 w-96 h-96 rounded-full opacity-30 blur-2xl z-10"
          animate={{ rotate: -360 }}
          transition={{ repeat: Infinity, duration: 120, ease: "linear" }}
        />
        <motion.div
          className="absolute -bottom-32 -right-32 w-80 h-80 rounded-full opacity-25 blur-2xl z-10"
          animate={{ rotate: 360 }}
          transition={{ repeat: Infinity, duration: 140, ease: "linear" }}
        />

        <div className="relative z-20 max-w-5xl mx-auto px-6 py-32 text-center">
          <motion.div
            className="flex flex-col md:flex-row items-center justify-center gap-4"
            initial={{ opacity: 0, y: -60, scale: 0.9 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            transition={{ duration: 1.2 }}
          >
            <img src={logo} alt="Prisu Experts Logo" className="w-20 md:w-28 lg:w-32" />
            <h1 className="text-5xl md:text-7xl font-extrabold leading-tight tracking-tight font-orbitron drop-shadow-lg">
              Prisu Experts
            </h1>
          </motion.div>

          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1.5 }}
            className="mt-6 text-2xl md:text-3xl font-semibold text-gray-200 drop-shadow-md"
          >
            High-Quality Data Solutions for AI & ML
          </motion.h2>

          <motion.p
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1.7 }}
            className="mt-6 text-lg md:text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed drop-shadow-md"
          >
            Power your AI with culturally authentic, high-quality, multilingual data solutions. Build smarter, scalable, and inclusive AI systems with The Prisu Experts.
          </motion.p>

          <motion.h3
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1.9 }}
            className="mt-10 text-3xl md:text-4xl font-bold text-gradient bg-gradient-to-r from-cyan-400 via-purple-400 to-pink-500 bg-clip-text text-transparent drop-shadow-lg"
          >
            Powering the Future of AI with Smarter, Inclusive Data Solutions
          </motion.h3>

          <motion.a
            whileHover={{ scale: 1.1, rotateZ: 5 }}
            whileTap={{ scale: 0.95, rotateZ: -5 }}
            className="mt-10 inline-block"
          >
            <Link
              to="/services1"
              className="px-10 py-4 rounded-full bg-gray-700 text-white font-bold text-lg shadow-md transition-transform duration-300 inline-block"
            >
              🚀 Get Started →
            </Link>
          </motion.a>
        </div>
      </section>

      {/* Case Studies Section */}
      <section className="py-20 px-6 text-center ">
        <h2 className="text-4xl font-extrabold mb-12 font-orbitron tracking-tight text-white">
          Case Studies / Success Stories
        </h2>
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 text-left">
          {caseStudies.map((study, index) => (
            <div key={index}>
              <h3 className="text-2xl font-bold mb-2 text-cyan-400">{study.title}</h3>
              <p className="text-gray-200 leading-relaxed">{study.description}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Core Services Snapshot */}
      <section className="py-20 px-6 text-center bg-gradient-to-br from-black via-gray-900 to-black text-white">
        <h2 className="text-4xl font-extrabold mb-12 font-orbitron tracking-tight">Core Services Snapshot</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-10 max-w-6xl mx-auto">
          {services.map((svc, idx) => (
            <motion.div
              key={idx}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: idx * 0.1 }}
              viewport={{ once: true }}
              whileHover={{ scale: 1.05 }}
              className={`rounded-2xl p-6 shadow-lg border border-gray-700 transition duration-300 text-left bg-gradient-to-br ${svc.style}`}
            >
              <motion.div
                className="text-4xl mb-4"
                animate={{ scale: [1, 1.1, 1] }}
                transition={{ repeat: Infinity, duration: 2, delay: idx * 0.2 }}
              >
                {svc.icon}
              </motion.div>
              <h3 className="text-xl font-bold mb-2">{svc.title}</h3>
              <p className="text-sm text-white/90 leading-relaxed">
                Enhance your AI with curated, multilingual, and culturally rich data.
              </p>
            </motion.div>
          ))}
        </div>
      </section>

      {/* Why Work With Us */}
      <section className="py-20 px-6 text-center bg-gradient-to-br from-black via-gray-900 to-black text-white">
        <h2 className="text-4xl font-extrabold mb-12 text-center font-orbitron">Why Work With Us</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {benefits.map((b, idx) => (
            <motion.div
              key={idx}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: idx * 0.1 }}
              viewport={{ once: true }}
              whileHover={{ scale: 1.03 }}
              className={`flex items-start gap-4 rounded-xl p-6 shadow-lg transition duration-300 bg-gradient-to-br ${b.bg}`}
            >
              <motion.div
                animate={{ scale: [1, 1.2, 1] }}
                transition={{ repeat: Infinity, duration: 2, delay: idx * 0.2 }}
                className="text-3xl w-12 h-12 flex items-center justify-center rounded-full bg-white text-black shadow-sm"
              >
                {b.icon}
              </motion.div>
              <p className="text-lg font-semibold">{b.title}</p>
            </motion.div>
          ))}
        </div>
      </section>

      {/* Why Prisu Experts (Features) */}
      <section className="py-20 px-6 text-center bg-gradient-to-br from-black via-gray-900 to-black text-white">
        <div className="max-w-6xl mx-auto text-center mb-12">
          <h2 className="text-4xl font-extrabold font-orbitron">Our Features</h2>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 max-w-5xl mx-auto">
          {features.map((ft, idx) => (
            <motion.div
              key={idx}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: idx * 0.15 }}
              viewport={{ once: true }}
              whileHover={{ scale: 1.05 }}
              className={`p-6 rounded-xl shadow-lg bg-gradient-to-r ${ft.color}`}
            >
              <h3 className="text-lg font-bold mb-3">{ft.title}</h3>
              <p className="text-sm leading-relaxed">{ft.desc}</p>
            </motion.div>
          ))}
        </div>
      </section>

      {/* Workflow */}
      <section className="py-20 px-6 text-center bg-gradient-to-br from-black via-gray-900 to-black text-white">
        <div className="max-w-5xl mx-auto text-center mb-16">
          <h2 className="text-4xl font-extrabold mb-16 font-orbitron tracking-tight">Our Workflow</h2>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-12 place-items-center">
          {steps.map((step, idx) => (
            <motion.div
              key={idx}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: idx * 0.15 }}
              viewport={{ once: true }}
              whileHover={{ scale: 1.1 }}
              className="flex flex-col items-center gap-4 cursor-pointer"
            >
              <div className="w-20 h-20 flex items-center justify-center rounded-full bg-gradient-to-br from-indigo-600 to-indigo-400 text-white text-3xl font-bold shadow-lg transition duration-300">
                {step.icon}
              </div>
              <p className="font-semibold text-lg text-center">{step.title}</p>
            </motion.div>
          ))}
        </div>
      </section>

      {/* Services & Industries */}
      <section className="py-20 px-6 text-center bg-gradient-to-br from-black via-gray-900 to-black text-white  ">
        <div className="max-w-6xl mx-auto text-center mb-16">
          <h2 className="text-4xl font-extrabold mb-4 tracking-tight font-orbitron">Our Services</h2>
          <p className="text-lg text-gray-300 max-w-3xl mx-auto font-raleway">
            From multilingual data collection to creative media solutions, we power AI with precision and cultural depth.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 max-w-6xl mx-auto mb-24">
          {servicesAndVideos.map(({ title, icon, items, video }, idx) => (
            <motion.div
              key={title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: idx * 0.1 }}
              viewport={{ once: true }}
              whileHover={{ scale: 1.02 }}
              className="relative overflow-hidden rounded-2xl shadow-lg border border-gray-700 p-8 bg-black group"
            >
              <video
                autoPlay
                muted
                loop
                playsInline
                className="absolute inset-0 w-full h-full object-cover opacity-30"
                src={video}
              />
              <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black/80 rounded-2xl pointer-events-none" />
              <div className="relative z-10 text-center">
                <motion.div
                  className="text-6xl mb-6"
                  animate={{ scale: [1, 1.15, 1], rotate: [0, 10, -10, 0] }}
                  transition={{ duration: 4, repeat: Infinity, ease: "easeInOut" }}
                >
                  {icon}
                </motion.div>
                <h3 className="text-2xl font-semibold font-orbitron mb-4">{title}</h3>
                <div className="flex flex-wrap justify-center gap-4">
                  {items.map((itm, j) => (
                    <Link
                      key={j}
                      to={itm.path}
                      onClick={storeScrollPosition}
                      className="flex-1 min-w-[140px] sm:min-w-[180px] px-5 py-2 text-sm bg-gray-800 bg-opacity-70 text-white font-medium rounded-full border border-indigo-500 hover:bg-indigo-600 transition text-center"
                    >
                      {itm.label}
                    </Link>
                  ))}
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        <div className="max-w-6xl mx-auto text-center mb-16">
          <h2 className="text-4xl font-extrabold tracking-tight font-orbitron">Industries We Serve</h2>
          <p className="text-lg text-gray-300 mt-4">Our expertise spans sectors where AI innovation and cultural understanding intersect.</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 max-w-5xl mx-auto">
          {industries.map((ind, idx) => (
            <Link key={idx} to={ind.href}   onClick={storeScrollPosition}>
              <motion.div
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: idx * 0.1 }}
                viewport={{ once: true }}
                whileHover={{ scale: 1.05 }}
                className="bg-gray-800 rounded-2xl shadow-md p-8 text-center transition border border-gray-700 hover:shadow-xl"
              >
                <motion.div
                  className="text-4xl mb-4"
                  animate={{ scale: [1, 1.1, 1] }}
                  transition={{ repeat: Infinity, duration: 2.5, delay: idx * 0.2 }}
                >
                  {ind.icon}
                </motion.div>
                <p className="text-lg font-semibold">{ind.label}</p>
              </motion.div>
            </Link>
          ))}
        </div>
      </section>
       {sections.map((Section, idx) => (
        <div key={idx} className="relative z-10">
          {Section}
        </div>
      ))}
    </main>
    
  );
}

export default Single1;
